import Link from "next/link";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  background: white;
  width: 100%;
  display: flex;
  justify-content: center;
  @media screen and (min-width: 800px) {
    display: none;
  }
`;

const Img = styled.img`
  width: 30%;
  height: calc(641px / 100 * 30%);
  @media screen and (max-width: 550px) {
    width: 40vw;
    height: auto;
  }
`;

export const MobileLogo = () => {
  return (
    <Wrapper>
      <Link href="/">
        <a>
          <Img src="/images/translogo_gray.png" alt="Faceguy logo" />
        </a>
      </Link>
    </Wrapper>
  );
};
